import SectionHeading from '@/components/feature/SectionHeading';

const steps = [
  {
    no: '01',
    icon: 'ri-focus-3-line',
    title: '先想清楚要不要买',
    desc: '把需求和预算写下来，区分「想要」和「需要」。冲动型消费是绝大多数踩坑的起点。',
  },
  {
    no: '02',
    icon: 'ri-file-list-3-line',
    title: '再读完规则和条款',
    desc: '重点看退换、退改、免责和期限。这些地方写得越含糊，越要多问一句。',
  },
  {
    no: '03',
    icon: 'ri-screenshot-2-line',
    title: '下单前后留好证据',
    desc: '商品页、客服承诺、订单详情都截图保存。发生争议时，谁能举证谁更主动。',
  },
  {
    no: '04',
    icon: 'ri-open-arm-line',
    title: '收货后按清单验收',
    desc: '对照清单逐项检查，发现问题第一时间申请退换。越早处理，可选的方案越多。',
  },
];

export default function MethodSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="一套通用方法"
        title="四步避雷法"
        description="不管买什么、签什么，这四步都能用。把清单里的具体动作套进来就行。"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {steps.map((step) => (
          <div key={step.no} className="relative rounded-lg border border-background-200 bg-background-100/50 p-5 md:p-6">
            <div className="flex items-center justify-between mb-4">
              <span className="w-11 h-11 rounded-md bg-accent-500 text-background-50 flex items-center justify-center text-xl">
                <i className={step.icon}></i>
              </span>
              <span className="font-heading text-3xl font-black text-background-300">{step.no}</span>
            </div>
            <h3 className="font-heading text-base font-bold text-foreground-950">{step.title}</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed font-body">{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}